import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import dt from '../../../../shared/theme';

const StyledBody = styled(Modal.Body)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: 40px 32px;

  ${props => dt(props).theme.isMobileOrTablet && `
    border-top: 0;
  `};

  > .title {
    margin-top: 0;
    margin-bottom: 10px;
    text-transform: uppercase;
    font-weight: ${props => dt(props).theme.fontWeightBold};
    font-size: 21px;
    line-height: 120%;
    color: ${props => dt(props).theme.bodyColor};
    display: flex;
    justify-content: space-between;

    ${props => dt(props).theme.isMobile && `
      > span.icon-lw-info-circle {
        display: none;
      }
    `};
  }

  > .content {
    margin-top: 16px;
    margin-bottom: 10px;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    line-height: 130%;
    color: ${props => dt(props).theme.secondaryColor};
  }
`;

export default function Body({
  title, content,
}) {
  return (
    <StyledBody>
      <p className="title">
        {title}
        <span className="icon-lw icon-lw-info-circle" />
      </p>
      {content.map(string => (
        <p className="content">{string}</p>
      ))}
    </StyledBody>
  );
}

Body.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
};
